var About = (function () {
    const URL = './ASPWebDataServise.asmx/';

    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    var _setContacts = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a) || a.HasError) {
            $('.list-contact').append('<div class="text-center m-5">Информация не найдена </div>');
            return false;
            //To DO:
        }

        $('.list-contact').html('');
        let item = a.Result;
        let txt = ` <div class="item-contact mt-4 ml-5">
                            <h5>${item.organization}</h5>
                            <div class="m-4">
                                <p class="item-contact-row"><span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span> ${item.address}</p>
                                ${item.phone ? `<p class="item-contact-row"><span class="glyphicon glyphicon-phone-alt" aria-hidden="true"></span> ${item.phone}</p>` : ``}
                                ${item.email ? `<p class="item-contact-row"><span class="glyphicon glyphicon-envelope" aria-hidden="true"></span> ${item.email}</p>` : ``}
                                ${item.website ? `<p class="item-contact-row"><span class="glyphicon glyphicon-globe" aria-hidden="true"></span><a href="${item.website}" target="_blank" rel="noopener noreferrer"> ${item.website} </a></p>` : ``}
                            </div>
                        </div>`;
        $('.list-contact').append(txt);
    };


    var _setFeedback = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a) || a.HasError) {
            alert(a.ErrorMessage);
            return false;
        }
        else {
            let formArr = $('#mailForm').serializeArray();

            formArr.forEach((item) => {
                $(`input[name='${item.name}']`).val('');
            });
            $(`textarea[name='textMail']`).val('');
            alert(`Сообщение успешно отправлено`);
        }
    }

    // точка входа 
    var init = () => {
        let promise = _fetchAsync(URL, 'GetContactOrganization', {}).then(response => _setContacts(response), err => console.error(`ошибка при получении данных: ${err}`));

        $.ajax({
            type: "Post",
            url: "./ASPWebDataServise.asmx/GetSettings",
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                if (!data.d.formQuestionVisible)
                    return false
                $('#divQuetion').append(`
<div class="item-contact mt-4 ml-5">
	<h5>Задайте ваш вопрос</h5>
	<div class="m-4 w-75">
		<form id="mailForm">
			<div class="form-group">
				<label for="fio">Фамилия Имя Отчество</label>
				<input type="text" class="form-control" name="fio"/>
			</div>
			<div class="form-group">
				<label for="email">Ваш E-mail </label>
				<input id="email" class="form-control" name="email"/>
			</div>
			<!--<div class="form-group">
                                    <label for="postcode">Ваш почтовый адрес</label>
                                    <input type="text" class="form-control" name="postcode" />
                                </div>-->
			<div class="form-group">
				<label for="themeMail">Тема обращения</label>
				<input type="text" class="form-control" name="themeMail"/>
			</div>
			<div class="form-group">
				<label for="textMail">Текст сообщения</label>
				<textarea class="form-control" name="textMail" rows="7"></textarea>
			</div>
			<div class="form-group">
				<div id="divCaptcha"/>
			</div>
			<button type="button" class="btn btn-primary" id="target">Отправить</button>
		</form>
	</div>
</div>
`)
                $("input#email").inputmask({
                    mask: "*{3,20}@*{3,20}.*{2,7}",
                    greedy: false,
                    clearMaskOnLostFocus: false,
                    clearIncomplete: true
                })
                let recaptcha = require('./recaptcha.js')
                recaptcha.init('divCaptcha')
                $('#target').on('click', About.SendMailClick);
            }
        });
        return false;
    };

    var sendMail_ = (e) => {
        e.preventDefault();

        let formArr = $('#mailForm').serializeArray(),
            sendObj = {},
            errObj = []

        formArr.forEach((item) => {
            if (!item.value) {
                errObj.push(item.name)
                return
            }
            sendObj[item.name] = item.value;
        });

        if (errObj.length) {
            let errStr = ''
            errObj.forEach((item) => {
                errStr += $(`[for='${item}']`)[0].innerText + ', '
            })
            alert('Вы не заполнили следующие поля: ' + errStr)
            return
        }

        let recaptcha = require('./recaptcha.js');
        if (!recaptcha.checkTextInCaptcha()) {
            alert(`Ошибка, вы не прошли проверку на человека`)
            return
        }
        
        if (Object.keys(sendObj).length == 4)
            _fetchAsync(URL, 'Feedback', sendObj).then(response => _setFeedback(response), err => console.error(`ошибка при получении данных: ${err}`));
        else
            alert(`Проверьте правильность ввода данных`);
            
    };

    return {
        // public методы
        init: init,
        SendMailClick: sendMail_
    };
}());


$(document).ready(function () {
    $("body").fadeIn(2000);
    About.init();
});